import GroupScreen from '../../components/layout/group-screen';
import { JOB_NAMES } from '../../constants/jobNames';
import PartnersList from './partner-list';
import PartnerConnectionsList from './partner-connection-list';
import ConnectionTypesList from './connection-type-list';

/**
 * Partners & Integrations — one section, three tables under tabs:
 * Partners · Connections · Connection Types.
 *
 * SMS DLT templates are NOT here: they are authored where they are used, in the
 * notification master's SMS channel, so an author never leaves the master to
 * register wording for it. Each tab shows only if the user
 * has any permission for that entity.
 */
const PartnersGroup = () => (
  <GroupScreen
    icon="handshake"
    iconBgColor="bg-rose-600"
    title="Partners & Integrations"
    subtitle="Partners, their connections, and the connection-type catalogue"
    testId="SCR-PartnersGroup"
    tabs={[
      { key: 'partners', header: 'Partners', leftIcon: 'handshake', jobs: [JOB_NAMES.PARTNERS], element: <PartnersList embedded /> },
      { key: 'connections', header: 'Connections', leftIcon: 'pi pi-link', jobs: [JOB_NAMES.PARTNER_CONNECTIONS], element: <PartnerConnectionsList embedded /> },
      { key: 'types', header: 'Connection Types', leftIcon: 'usb', jobs: [JOB_NAMES.CONNECTION_TYPES], element: <ConnectionTypesList embedded /> },
    ]}
  />
);

export default PartnersGroup;
